import { Component, Mixins, Prop } from 'vue-property-decorator'
import PaymentHandlerMixin from '~/components/common/modals/payment/PaymentHandlerMixin'
import { PayPal } from '~/plugins/paypal-payment-processor'

@Component
export default class PaymentMixin extends Mixins(PaymentHandlerMixin) {
  @Prop({ type: Number, required: true }) packageId!: number
  @Prop({ type: String, default: '' }) billingAgreement!: string
  @Prop({ type: Boolean, default: false }) isFreeTrial!: boolean
  @Prop({ type: Boolean, default: false }) isRecurrent!: boolean
  @Prop({ type: String, default: '' }) buttonText!: string

  paypal: null | { initAuthFlow: PayPal.InitAuthFlow; teardownSetup: PayPal.TeardownSetup } = null
  isPaypalInitializing = false
  isSending = false
  serverError = ''

  paypalAuth() {
    if (this.isPaypalInitializing) { return }
    this.$mixpanel.track(this.$mixpanel.events.BRAINTREE_PAYPAL_CLICK)

    this.isPaypalInitializing = true
    this.paypal.initAuthFlow()
      .then(() => { this.isPaypalInitializing = false })
      .catch(() => (this.isPaypalInitializing = false))
  }

  initPayPal({ success, fail }) {
    this.paypal = this.$initPayPal({
      config: {
        packageId: this.packageId.toString(),
        isFreeTrial: this.isFreeTrial,
        billingAgreement: this.billingAgreement,
        environment: this.$config.BRAINTREE_ENV || 'production'
      },
      onEvent: ({ name }) => {
        if (name !== 'before_submit') { return }
        this.isSending = true
      },
      success,
      fail
    })
  }

  teardownPayPal() {
    if (!this.paypal) { return }

    this.paypal.teardownSetup()
      .then(() => (this.paypal = null))
  }

  errorHandler(err) {
    this.isSending = false
    this.serverError = err.message
    this.$sentry.captureException(Error(err.message))
  }
}
